import { BaseModel } from 'app/core/models/base.model';

export class MachineType extends BaseModel {
	name: string;
	description: string;
}
